module.exports = __webpack_public_path__ + "img/1f378.68d2c9d.svg";